// src/components/msteams-connect-button/MsTeamsConnectButton.tsx
import React, { useMemo } from "react";
import { useNovu } from "../../hooks/NovuProvider.js";
import { NovuUI } from "../NovuUI.js";
import { withRenderer } from "../Renderer.js";
import { DefaultMsTeamsConnectButton } from "./DefaultMsTeamsConnectButton.js";
import { jsx } from "react/jsx-runtime";
var MsTeamsConnectButtonInternal = withRenderer((props) => {
  const { container, appearance, ...defaultProps } = props;
  const novu = useNovu();
  const options = useMemo(() => {
    return {
      container,
      appearance,
      options: novu.options
    };
  }, [container, appearance, novu.options]);
  return /* @__PURE__ */ jsx(NovuUI, { options, novu, children: /* @__PURE__ */ jsx(DefaultMsTeamsConnectButton, { ...defaultProps }) });
});
MsTeamsConnectButtonInternal.displayName = "MsTeamsConnectButtonInternal";
var MsTeamsConnectButton = React.memo((props) => {
  return /* @__PURE__ */ jsx(MsTeamsConnectButtonInternal, { ...props });
});
MsTeamsConnectButton.displayName = "MsTeamsConnectButton";
export {
  MsTeamsConnectButton
};
//# sourceMappingURL=MsTeamsConnectButton.js.map